import React, { useEffect, useRef } from 'react';
import { faqs } from '../mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const ref = useRef(null);
  useEffect(() => {
    const els = ref.current?.querySelectorAll('.reveal');
    if (!els) return;
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('is-visible')),
      { threshold: 0.15 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-20 md:py-28 paper-bg">
      <div className="max-w-3xl mx-auto px-5 md:px-10">
        <div className="text-center mb-12 reveal">
          <p className="font-script text-2xl text-[#7a8a4c] mb-2">Questions</p>
          <h2 className="font-serif text-3xl md:text-5xl text-[#2c3f25] tracking-tight">Common things people ask</h2>
        </div>

        <div className="reveal">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-[#f0e9d2] rounded-xl px-5 border-none"
              >
                <AccordionTrigger className="text-left font-serif text-[#2c3f25] text-base md:text-lg hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#3d4a36] text-[15px] leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
